
  <template>
  <div class="footer">
    <b-row class="ml-1" v-if="company">
        <b-form-text class="mr-4">Date added: {{company.dateCreated| dateTime }}</b-form-text>
        <b-form-text>Last modified: {{company.dateModified| dateTime }}</b-form-text>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateTime } from '@/shared/filters';

export default {
  name: 'Footer',
  props: ['company'],
  filters: {
    dateTime,
  }
};
</script>
